// extracted by mini-css-extract-plugin
export default {"buttonContainer":"modal-info_buttonContainer__72H2M"};